import { action, ActionType } from "typesafe-actions";
import { IFlyerDetailPage } from "../../../../../../../types/flyer-detail-data/flyer-detail-page/flyer-detail-page.interface";
import { IError } from "../../../../../../../../../redux/actions/errorHandlingAction";
import { FlyerDetailPageForm } from "../types/flyer-detail-page-form.interface";

export enum FlyerDetailPageFormPageActions {
  FetchPage = "FlyerDetailPageForm/FetchPage",
  FetchPageSuccess = "FlyerDetailPageForm/FetchPageSuccess",
  FetchPageFailure = "FlyerDetailPageForm/FetchPageFailure",

  SavePage = "FlyerDetailPageForm/SavePage",
  SavePageFailure = "FlyerDetailPageForm/SavePageFailure",
  SavePageSuccess = "FlyerDetailPageForm/SavePageSuccess",

  Reset = "FlyerDetailPageForm/Reset",
}

export const fetchPage = () => action(FlyerDetailPageFormPageActions.FetchPage);
export const fetchPageSuccess = (page: IFlyerDetailPage) =>
  action(FlyerDetailPageFormPageActions.FetchPageSuccess, page);
export const fetchPageFailure = (error: IError) =>
  action(FlyerDetailPageFormPageActions.FetchPageFailure, error);

export const savePage = (changes: FlyerDetailPageForm) =>
  action(FlyerDetailPageFormPageActions.SavePage, changes);
export const savePageSuccess = (page: IFlyerDetailPage) =>
  action(FlyerDetailPageFormPageActions.SavePageSuccess, page);
export const savePageFailure = (error: IError) =>
  action(FlyerDetailPageFormPageActions.SavePageFailure, error);

export const reset = () => action(FlyerDetailPageFormPageActions.Reset);

const actionCreators = {
  fetchPage,
  fetchPageSuccess,
  fetchPageFailure,

  savePage,
  savePageSuccess,
  savePageFailure,

  reset,
};

export type FlyerDetailPageFormPageActionType = ActionType<typeof actionCreators>;
